import React, { useRef, useEffect } from "react";

import { useLocales, useUniqueId, useChangeHandler } from "hooks";

interface Props {
  label: string;
  onChange: (date: string) => void;
}

export const DatePicker: React.FC<Props> = ({ label, onChange }) => {
  const { t } = useLocales();
  const id = useUniqueId();
  const inputRef = useRef(null);

  useChangeHandler(`input#${id}`, onChange);

  useEffect(() => {
    new window.Pikaday({
      field: inputRef.current,
      format: "DD.MM.YYYY",
      firstDay: 1,
      theme: "admin-theme",
      i18n: {
        previousMonth: t("history.datepicker.previousMonth"),
        nextMonth: t("history.datepicker.nextMonth"),
        months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((monthNumber) =>
          t(`history.datepicker.months.${monthNumber}`)
        ),
        weekdays: [1, 2, 3, 4, 5, 6, 7].map((monthNumber) =>
          t(`history.datepicker.weekdays.${monthNumber}.long`)
        ),
        weekdaysShort: [1, 2, 3, 4, 5, 6, 7].map((monthNumber) =>
          t(`history.datepicker.weekdays.${monthNumber}.short`)
        ),
      },
    });
  }, [t]);

  return (
    <div className="date-picker-component">
      <label htmlFor={id} className="control-label">
        {label}
      </label>
      <input ref={inputRef} type="text" className="form-control" id={id} />
    </div>
  );
};
